var defaultTemplates = {
    text: function text() {
        return '';
    },
    button: function button(param) {
        var isRelevantSorted = param.isRelevantSorted;
        return isRelevantSorted ? 'See all results' : 'See relevant results';
    }
};

export { defaultTemplates as default };
